@if (!loading && (ticketCounterObservable$ | async); as counterHelper) {
  <div class="padding">
    <mat-list>
      <mat-list-item>
        <div class="ticketButtonContainer">
          <div class="ticketContainer">
            <div>
              <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%">
                <p class="itemLine orderDesignation" matLine>
                  {{ res.get('Tickets') }}
                </p>
                @if (isDownloaded) {
                  <mat-icon
                    [svgIcon]="res.svgName('Order-Selection-StateOffline-Image')"
                    class="orderWorksCommonIcon"
                  ></mat-icon>
                }
              </div>
            </div>
            <table matLine class="itemLine orderTable">
              <tr>
                <td class="orderWorksAll">
                  {{ res.get('Tickets-Selection-TotalNumber', counterHelper?.CountTicketsAll) }}
                </td>
                <td>
                  <div fxLayout="row" fxLayout.xs="column">
                    <div class="orderWorksCommon orderWorksDone">
                      <mat-icon
                        [svgIcon]="res.svgName('Order-Selection-StateDone-Image')"
                        class="orderWorksCommonIcon"
                      ></mat-icon>
                      {{ res.get('Tickets-Selection-TotalTicketsDone', counterHelper?.CountTicketsFinished) }}
                    </div>
                    <div class="orderWorksCommon orderWorksPartial">
                      <mat-icon
                        [svgIcon]="res.svgName('Order-Selection-StatePartial-Image')"
                        class="orderWorksCommonIcon"
                      ></mat-icon>
                      {{ res.get('Tickets-Selection-TotalTicketsInEditing', counterHelper?.CountTicketsEditing) }}
                    </div>
                    <div class="orderWorksCommon orderWorksPartial">
                      <mat-icon
                        [svgIcon]="res.svgName('Order-Selection-StateOpen-Image')"
                        class="orderWorksCommonIcon"
                      ></mat-icon>
                      {{ res.get('Tickets-Selection-TotalTicketsOpen', counterHelper?.CountTicketsOpen) }}
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div style="padding-top: 20px">
            <button class="ticketConfirmButton" mat-raised-button (click)="selectTicketMode()" [disabled]="!canSelect">
              <mat-icon
                [svgIcon]="res.svgName('Order-Selection-ArrowForward-Image')"
                class="ticketConfirmButtonIcon"
              ></mat-icon>
            </button>
          </div>
        </div>
      </mat-list-item>
    </mat-list>
  </div>
}
